import React from "react";
import ReactHtmlParser from 'react-html-parser';
import WhatIsTechSoup from '../components/whatIsTechSoupModal';
import NotNowModal from '../components/notNowModal';
//import UploadDocument from '../components/dragAndDrop';
import { Inprogress, Revoked, SomethingWentWrong, Success } from '../components/getStarted';
import { parseMessages } from '../../../utilityHelper';
import { Row, Container, Card, Button, Loader, } from "kepler";

const templateData = $('body').data();
const propertyInfo = parseMessages('ppcc/confirmation/confirmation-home');

//let filetests = {}, fileData = {};

export default class Consent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
			modalIsOpen: false,
			collectToken: false,
			confirmationStatus: templateData.confirmationStatus,
			notNowModal: false,
			//uploadFile: templateData.uploadFile,
			formData: false,
			loader: false,
			fileInfo: {},
			errorPage:false
        };
		this.toggleModal = this.toggleModal.bind(this);
		this.toggleNotNowModal = this.toggleNotNowModal.bind(this);
		this.toggleUpload =  this.toggleUpload.bind(this);
		this.updateFileFields = this.updateFileFields.bind(this);
    }

	updateFileFields(fileInfo, formData){
		if(formData.formdata){
			this.setState({
				formData: formData.formdata,
				fileInfo: fileInfo
			});
		}
	}

	toggleModal(visible) {
		this.setState({
			modalIsOpen: true,
			notNowModal: false
		});
	}

	toggleNotNowModal(visible) {
		this.setState({
			notNowModal: true,
			modalIsOpen: false
		});
	}

	toggleUpload() {
		const self =  this;
		let _csrf = $('body').attr('data-csrf');
		self.setState({
			loader: true,
			notNowModal: false
		});
		// if(!self.state.uploadFile) {
			let params = { _csrf: _csrf };
			$.post('/givingfund/ppcc/shareConsent', params, (result) => { 
              let confirmationStatus = {
            	  state : result.status
              }
              if(result.result){
                self.setState({
					modalIsOpen: false,
					collectToken: false,
					confirmationStatus: confirmationStatus,
					loader: false
	       		});
               } else {
                    self.setState({
                        modalIsOpen: false,
						collectToken: false,
						confirmationStatus: confirmationStatus,
						loader: false,
						errorPage: true
                    });
               }    
              
            });
		/* } else {
			if (self.state.formData) {
				self.setState({
		            loader: true,
		            notNowModal: false
		        });
				var formData = self.state.formData ? new FormData() : null;
				formData.append('file', self.state.fileInfo);
				let request = new XMLHttpRequest();
				request.open("POST", "/givingfund/ppcc/shareConsentWithDoc");
				request.setRequestHeader('X-CSRF-Token', _csrf);
				request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
				request.onreadystatechange = function() {
			        if (request.readyState == 4 && request.status == 200) {
			            let responseJson = JSON.parse(request.responseText);
			            let confirmationStatus = {
			            	state : responseJson.status
			            }
			            if (responseJson.result){
			            	self.setState({
								modalIsOpen: false,
								collectToken: false,
								confirmationStatus: confirmationStatus,
								loader: false
				       		});
			            } else {
		                    self.setState({
		                        modalIsOpen: false,
								collectToken: false,
								confirmationStatus: confirmationStatus,
								loader: false,
								errorPage: true
		                    });
		               }
			            
			       	}
			    };
				request.send(formData);
			}
		} */
		
	}

    render() {
    	
    	let labels = propertyInfo.consent;
		const shareConsent = labels.p3;
    		if (this.state.errorPage) {
    			return (<SomethingWentWrong/>);
    		} else if (this.state.confirmationStatus.state === 'In Progress' ) {
				return (<Inprogress/>);
    		} else if (this.state.confirmationStatus.state === 'Confirmed' ) {
				return (<Success/>);
    		} else if (this.state.confirmationStatus.state === 'Revoked') {
            	return (<Revoked/>);
        	} else {
		        return (
			            <Container
			                id="ConfirmCharityWapper"
			                maxWidth={800}
			                className="container"
			            >
			                <Row>
			                    <Card id="setupConfirmation" className="roundedBox">
									<div className="bodyContainer">
										
			                            <h3>{labels.title}</h3>
										<p className="vx_text-body-md body_text">{labels.p1} <a onClick={this.toggleModal}>{propertyInfo.confirm.whatistechsoup}</a></p>
										<p className="vx_text-body-md body_text">{labels.p2}</p>
										<p className="vx_text-body-md body_text">{ ReactHtmlParser(shareConsent) }</p>

										{/*this.state.uploadFile && <UploadDocument uploadedFileContent={this.updateFileFields} filetests={filetests} fileData={fileData} />*/}
											
										<p className="vx_text-3">
											<Button onClick={this.toggleUpload}>
											{labels.shareBtn}</Button>
										</p>
										<p className="vx_text-3">										
											<a onClick={this.toggleNotNowModal}>{labels.notNowBtn}</a>
										</p>
										
									</div>
									<WhatIsTechSoup isOpen={this.state.modalIsOpen} />

									<NotNowModal viewNotStarted={this.props.viewNotStarted} isOpen={this.state.notNowModal}/>
									
			                    </Card>
			                </Row>
			                <Loader show={this.state.loader} priority={10} type="fixed" size="lg"></Loader>
			            </Container>
		        );
	       }
    }
};



// WEBPACK FOOTER //
// ./ppcc/confirmation/components/consent.js